import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Toolbar,
  Tooltip,
  useMediaQuery
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { CmpTypographyField } from '../../../component/ToolBox/ToolBox';
import { exportToExcel } from '../../../Utility/Utilitys';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { distributionVANItemListApi } from '../../Purchase/actions';

const toolbar = {
  backgroundColor: '#0d73bb',
  color: 'white',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: '40px !important'
};

export const ItemListVanModal = ({ data, open, onClose }) => {
  const vMediaQuery = useMediaQuery('max-width:900px');

  const [sDetail, setDetail] = useState([]);

  const fDetail = async () => {
    const obj = {
      v_VocTyp: data?.A_VocTyp,
      v_VocNo: data?.A_VocNo,
      v_Truck: data?.TruckID
    };
    const result = await distributionVANItemListApi(obj);
    console.log('result,', result);

    if (result?.ResultSet?.VanItems.length > 0) {
      setDetail(result?.ResultSet?.VanItems);
    } else {
      setDetail([]);
    }
  };

  const fClose = async () => {
    setDetail([]);
    onClose();
  };

  const columns = [
    {
      field: 'vocTyp',
      headerName: 'Voc.Typ',
      width: vMediaQuery ? 50 : 90,
      type: 'text',
      cellClassName: 'editable-cell',
      editable: true
    },
    {
      field: 'itemCode',
      headerName: 'ItemCode',
      width: vMediaQuery ? 50 : 90,
      type: 'text',
      cellClassName: 'editable-cell',
      editable: true
    },

    {
      field: 'itemName',
      headerName: 'ItemName',
      width: vMediaQuery ? 70 : 250,
      type: 'text',
      editable: true,
      cellClassName: 'editable-cell'
    },
    { field: 'unitName', headerName: 'Unit', width: vMediaQuery ? 70 : 100, type: 'text' },
    {
      field: 'loadedQty',
      headerName: 'Loaded Qty',
      width: vMediaQuery ? 70 : 100,
      type: 'number',
      editable: false
      //  cellClassName: 'readonly-cell'
    },
    {
      field: 'baseQty',
      headerName: 'Base Qty',
      width: vMediaQuery ? 70 : 100,
      type: 'number'
      //  cellClassName: 'editable-cell',
      //editable: true
    },
    {
      field: 'distriQty',
      headerName: 'Distribution Qty',
      width: vMediaQuery ? 70 : 150,
      type: 'number'
      // cellClassName: 'editable-cell',
      //editable: true
    },
    {
      field: 'balanceQty',
      headerName: 'Balance Qty',
      width: vMediaQuery ? 70 : 120,
      type: 'number'
      //cellClassName: 'readonly-cell'
    }
  ];

  const handleExport = () => {
    exportToExcel(sDetail, 'ItemList_data', 'ItemList');
  };

  useEffect(() => {
    if (open) {
      fDetail();
    }
  }, [open]);
  return (
    <Dialog open={open} onClose={fClose} maxWidth="lg">
      <Toolbar sx={toolbar}>
        <DialogTitle
          sx={{ backgroundColor: '#0d73bb', color: 'white', padding: '0 4px !important' }}>
          Van Item List
        </DialogTitle>
        <IconButton edge="end" color="inherit" onClick={fClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Toolbar>
      <DialogContent sx={{ '&.MuiDialogContent-root': { padding: '10px !important' } }}>
        <Grid container columnSpacing={2} rowSpacing={0} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={12} md={5} lg={5}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: 'center' }}>
              <Grid item xs={2} sm={1.5} lg={2} md={2}>
                <CmpTypographyField xcomponent={'span'} xText={'Voucher'} />
              </Grid>
              <Grid item xs={0.5} sm={0.5} lg={0.5} md={0.5}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={9.5} sm={9.5} lg={9.5} md={9.5}>
                <CmpTypographyField
                  xcomponent={'span'}
                  xText={`${data?.A_VocNo} - ${data?.VocName}`}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={4}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: 'center' }}>
              <Grid item xs={2} sm={2.5} lg={2} md={2}>
                <CmpTypographyField xcomponent={'span'} xText={'Location'} />
              </Grid>
              <Grid item xs={0.5} sm={0.5} lg={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={9.5} sm={8.5} lg={8} md={8}>
                <CmpTypographyField xcomponent={'span'} xText={data?.LocName} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: 'center' }}>
              <Grid item xs={2} sm={2} lg={2.5} md={2.5}>
                <CmpTypographyField xcomponent={'span'} xText={'Truck'} />
              </Grid>
              <Grid item xs={0.5} sm={1} lg={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={7.5} sm={7} lg={6} md={6}>
                <CmpTypographyField xcomponent={'span'} xText={data?.TruckName} />
              </Grid>
              <Grid
                item
                xs={2}
                sm={2}
                lg={2}
                md={2}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                <Tooltip title="Export" placement="top">
                  <IconButton
                    color="primary"
                    onClick={handleExport}
                    size="small"
                    sx={{
                      padding: '0px 2px',
                      '& .MuiSvgIcon-root': {
                        padding: '0px',
                        fontSize: '20px'
                      }
                    }}>
                    <DownloadOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} mt={1}>
            <Box
              sx={{
                height: '55vh',
                width: '100%'
              }}>
              <DataGridPro
                className="gridTable"
                rowHeight={30}
                headerHeight={30}
                rows={sDetail}
                columns={columns}
                getRowId={(row) => row.Id}
                disableRowSelectionOnClick
                hideFooter
                disableSelectionOnClick
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
